export enum PreFundingStatus {
  none = 0,
  monthly = 1,
  annual = 2,
}

export interface Employer {
  id: string;
  name: string;
  description?: string;
  adminUserIds: string[];
  totalMembers: number;
  benefitPlanIds: string[];
  isActive: boolean;
  
  // Payment fields
  stripeCustomerId?: string;
  paymentMethodId?: string;
  paymentMethodVerified: boolean;
  paymentMethodAddedAt?: Date;
  monthlyBudgetLimit?: number;
  
  // Pre-funding
  preFundingStatus: PreFundingStatus;
  preFundedBalance?: number;
  preFundingExpiresAt?: Date;
  preFundingDiscountPercent: number;
  
  // Compliance
  stopLossPolicyId?: string;
  hasCobraCoverage: boolean;
  spdConfigurationId?: string;
  lastComplianceCheck?: Date;
  
  // Timestamps
  createdAt: Date;
  lastUpdated: Date;
}

